import { render } from "./GetInTouch.vue?vue&type=template&id=4cada83a"
import script from "./GetInTouch.vue?vue&type=script&lang=js"
export * from "./GetInTouch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__